import { ContactUsSchema } from './contact-us-schema';
import { Form } from './form';
import { FormConfirmation } from './form-confirmation';
import { zodResolver } from '@hookform/resolvers/zod';
import { BaseCard } from '@midwest/web/card';
import { FormProvider, useForm } from 'react-hook-form';

// --------------------------------------------------------------------------

export const FormCard = ({ className }: { className?: string }) => {
  const form = useForm({
    defaultValues: {
      r_First_Name: '',
      r_Last_Name: '',
      r_Email: '',
      r_Phone: '',
      r_ZIP: '',
      r_topic: 'another-topic',
      'another-topic': '',
      'g-recaptcha-response': '',
    },
    resolver: zodResolver(ContactUsSchema),
    mode: 'onBlur',
  });

  return (
    <BaseCard className={className} raised={true}>
      <FormProvider {...form}>
        {form.formState.isSubmitSuccessful ? <FormConfirmation /> : <Form />}
      </FormProvider>
    </BaseCard>
  );
};
